<div class="{{type?'m0 webview box':''}}">
  <div class="container" [formGroup]="subsForm">
    <div formGroupName="paymentDetails">
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
        formControlName="availablePaymentMethodSelection">
        <div (click)="controlChange(i)" *ngFor="let paymentCard of paymentOptions; index as i; trackBy: trackByPaymentMethod" role="button" tabindex="0" aria-label="Select option" (keydown.enter)="controlChange(i)" (keydown.space)="$event.preventDefault(); controlChange(i)">
          <mat-radio-button [disableRipple]="true" class="example-radio-button" [value]="paymentCard">
            <app-gdo-payment-card [paymentCard]="paymentCard" [i]="i" [defaultPaymentMethodNo]="defaultPaymentMethodNo"
              [paymentOptions]="paymentOptions" (cardDefault)="defaultCard($event)"
              (cardDelete)="deleteCard($event)"></app-gdo-payment-card>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
    <div *ngIf="allowAddPaymentMethod" class="{{type? 'main-container-wv fab-container': 'main-container cir-border'}} ">
      <button mat-fab color="red" class="{{isWebView?'mat-fab-wv':'mat-fab'}}" (click)="addNewPaymentMethod()">
        <span class="material-icons">add</span>
      </button>
      <button class="background-none border-none" (click)="addNewPaymentMethod()">
        <p class="{{type? 'blue-color font-14 font-weight-600': 'red-color font-14'}} ">Add New Payment Option</p>
      </button>
    </div>
  </div>
</div>

<div *ngIf="!type" class="container-buttons">
  <button class="danger-btn" (click)="onCancel()" mat-button matStepperPrevious>Cancel</button>
  <button class="primar-btn" mat-button matStepperPrevious>Previous</button>
  <button mat-button class="primar-btn" matStepperNext [disabled]="
          subsForm.get('paymentDetails').invalid ||
          !subsForm.get('paymentDetails').controls.availablePaymentMethodSelection
            .value
        ">
    Next
  </button>
</div>

<div *ngIf="type" class="container-buttons-wv flex-column-wv">
  <!-- <button class="button-with-radius" (click)="onCancel()" mat-button matStepperPrevious>
      Cancel
    </button> -->
  <button mat-button class="button-with-radius  {{isAcura ? 'AcuraBtn-disabled' : 'HondaBtn-disabled'}}" matStepperNext [disabled]="
        subsForm.get('paymentDetails').invalid ||
        !subsForm.get('paymentDetails').controls.availablePaymentMethodSelection
          .value
      ">
    Next
  </button>
  <button class="button-wv" mat-button matStepperPrevious>
    Previous
  </button>
</div>

<!-- <mat-grid-tile *ngFor="let paymentCard of paymentOptions; index as i; trackBy: trackByNgForItem">
    <div class="main-container">
      <app-payment-card
        [paymentCard]="paymentCard"
        [i]="i"
        (cardDelete)="deleteCard($event)"
      ></app-payment-card>
    </div>
  </mat-grid-tile> -->
